const leaflets = {
    "carrefour": {
        "config": {
            "primary-color": "#01538A",
            "secondary-color": "#E1001B",
            "tertiary-color": "#ffdd00",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "primary-alpha-color": "rgba(35, 94, 157, 0.7)",
            "clientIcon": require("assets/images/icona-Carrefour.png"),
            "serverPath": "demo4.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Carrefour Iper | Volantino interattivo",
            "shareFlyerURL": "https://demo4.volantinointerattivo.net?v=384",
            "shareProductSentence": "Guarda il Volantino di Carrefour Iper!",
            "ogTitleMeta": "Carrefour Iper | Volantino interattivo",
            "ogDescriptionMeta": "Dai uno sguardo al volantino interattivo di Carrefour Iper. Offerte valide dal 06/04 al 21/04",
            "ogImageMeta": "https://demo4.volantinointerattivo.net/media/images/carrefour_fb.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": false,
            "ga_tracking_id": "UA-152069090-",
            "release_id": "1",
            "send_grocery_list_to_market": true,
            "grocery_list_min_value": 20,
            "client_id": 37,
            "signboard_id": 59,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": "/media/images/banner_carrefour.jpg",
            "category_banner_mobile": "/media/images/banner_carrefour_mobile.jpg",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "type": "leaflet",
            "product_banner": "",
            "href_banner": "",
            "internal_banner_click": false,
            "external_banner_click": false,
            "add_icon_list": true,
            "no_link_to_site": false,
            "hide_logo": false,
            "small_logo": false,
            "hide_listPages": true,
            "version": 384
        },
        "leaflet": {
            "name": "demo Carrefour",
            "code": "384",
            "id_campaign": "384",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/Indice-Carrefour-demo_EMZY201.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 25.338502222545397,
                            "left": 5.672612727505431,
                            "width": 43.122873258447214,
                            "height": 12.54077695085486
                        }
                    },
                    {
                        "page": 12,
                        "blueprint": {
                            "top": 25.35809224260558,
                            "left": 51.3298444323857,
                            "width": 43.122873258447214,
                            "height": 12.54077695085486
                        }
                    },
                    {
                        "page": 16,
                        "blueprint": {
                            "top": 39.20475307471127,
                            "left": 5.664217587658808,
                            "width": 43.122873258447214,
                            "height": 12.54077695085486
                        }
                    },
                    {
                        "page": 22,
                        "blueprint": {
                            "top": 39.18036962161762,
                            "left": 51.45614618921869,
                            "width": 43.122873258447214,
                            "height": 12.54077695085486
                        }
                    },
                    {
                        "page": 26,
                        "blueprint": {
                            "top": 52.97609334062621,
                            "left": 5.741196163359863,
                            "width": 43.122873258447214,
                            "height": 12.54077695085486
                        }
                    },
                    {
                        "page": 32,
                        "blueprint": {
                            "top": 52.96695337189189,
                            "left": 51.46207135403606,
                            "width": 43.122873258447214,
                            "height": 12.651791145783395
                        }
                    },
                    {
                        "page": 36,
                        "blueprint": {
                            "top": 66.76311480541119,
                            "left": 5.759942996306626,
                            "width": 43.122873258447214,
                            "height": 12.651791145783395
                        }
                    },
                    {
                        "page": 40,
                        "blueprint": {
                            "top": 66.80141941651011,
                            "left": 51.41174908188106,
                            "width": 43.122873258447214,
                            "height": 8.229668576904885
                        }
                    },
                    {
                        "page": 50,
                        "blueprint": {
                            "top": 80.73688425830112,
                            "left": 5.614887468394771,
                            "width": 43.122873258447214,
                            "height": 15.068330314069504
                        }
                    },
                    {
                        "page": -1,
                        "type": "url",
                        "url": "https://volantinointerattivo.net",
                        "target": "_blank",
                        "blueprint": {
                            "top": 3.4048332708879716,
                            "left": 69.19851380042462,
                            "width": 28.19532908704883,
                            "height": 5.769951292618956
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Casa e Cucina",
                    "subcategories": [
                        "Altro",
                        "Bagno",
                        "Stoviglie",
                        "Pentole, padelle e pirofile"
                    ]
                },
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Olio",
                        "Colazione",
                        "Rossi",
                        "Snack Salati",
                        "Dispensa",
                        "Snack Dolci",
                        "Pasta"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Verdure",
                        "Panati",
                        "Gelati",
                        "Carne"
                    ]
                },
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Pasta",
                        "Yogurt",
                        "Formaggi",
                        "Salumi",
                        "Vegetali",
                        "Ittico"
                    ]
                },
                {
                    "category_name": "Ortofrutta",
                    "subcategories": [
                        "Verdura",
                        "Frutta"
                    ]
                },
                {
                    "category_name": "Bevande",
                    "subcategories": [
                        "Acqua",
                        "Vini e Spumanti",
                        "Birre",
                        "Bibite"
                    ]
                },
                {
                    "category_name": "Igiene Persona",
                    "subcategories": [
                        "Intima",
                        "Corpo",
                        "Capelli",
                        "Viso"
                    ]
                },
                {
                    "category_name": "Pet",
                    "subcategories": [
                        "Food",
                        "Care"
                    ]
                },
                {
                    "category_name": "Auto&Moto",
                    "subcategories": [
                        "Cura auto&moto",
                        "Oli e liquidi"
                    ]
                },
                {
                    "category_name": "Gastronomia",
                    "subcategories": [
                        "Piatti Pronti"
                    ]
                },
                {
                    "category_name": "Igiene Casa",
                    "subcategories": [
                        "Extra"
                    ]
                },
                {
                    "category_name": "Abbigliamento",
                    "subcategories": [
                        "Scarpe",
                        "Accessori"
                    ]
                },
                {
                    "category_name": "Giardino e Giardinaggio",
                    "subcategories": [
                        "Barbecue e picnic"
                    ]
                },
                {
                    "category_name": "Prima infanzia",
                    "subcategories": [
                        "Puericultura"
                    ]
                },
                {
                    "category_name": "No Food",
                    "subcategories": [
                        "Elettronica"
                    ]
                },
                {
                    "category_name": "Giochi e Giocattoli",
                    "subcategories": [
                        "Giochi Creativi",
                        "Altro",
                        "Bambole e Peluche"
                    ]
                },
                {
                    "category_name": "Sport e Tempo Libero",
                    "subcategories": [
                        "Altro"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_1_D6TuleZ.jpg",
                    "products": [
                        {
                            "item_id": "cstm32338279",
                            "field1": "Tovaglioli",
                            "field2": "2 veli",
                            "field3": "Carrefour",
                            "field4": "conf 100 pezzi mis 33x33 cm",
                            "description": "Tovaglioli 2 veli Carrefour conf 100 pezzi mis 33x33 cm",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 14.949419258149117,
                                "left": 49.79830148619958,
                                "width": 45.1592356687898,
                                "height": 34.35275384038965
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_3kcLm6G.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83235683",
                            "field1": "Carrefour Olio ",
                            "field2": "Extra Vergine di Oliva",
                            "field3": "gusti classico o delicato 1 lt",
                            "field4": "",
                            "description": "Olio Extra Vergine di Oliva Carrefour gusti classico o delicato 1 lt",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "classico",
                                "delicato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 49.30217309853878,
                                "left": 49.79830148619958,
                                "width": 45.1592356687898,
                                "height": 40.80648182840015
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/OLIOEXTRAVERGINEDELICATOCRF-8012666031221-1_KTldXQS.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_yrzxeck_Sp4tRIY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "",
                                    "data": {
                                        "specifiche": "Energia 3404 kJ, Grassi 92 g, di cui acidi grassi saturi 14 g, Carboidrati 0 g, di cui zuccheri 0 g, Proteine 0 g, Sale 0 g, (Fonte: carrefour.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/THFG3nyJd6/images/OLIOEXTRAVERGINEDELICATOCRF-8012666031221-1.webp"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm67802997",
                            "field1": "Mulino Bianco",
                            "field2": "Abbracci, Nascondini o Ritornelli",
                            "field3": "700 g",
                            "field4": "",
                            "description": "Abbracci, Nascondini o Ritornelli Mulino Bianco 700 g",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Abbracci",
                                "Nascondini",
                                "Ritornelli"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 54.07924316223305,
                                "left": 4.994692144373664,
                                "width": 44.803609341825904,
                                "height": 36.02941176470588
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Abbracci_350g_ZYMt8uq.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Nascondini_600g_WRt5ciy.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/pack_biscotto_ritornelli_2Tl3OtI.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_3Db24Ky_SBkxm3p.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Mulino_Bianco_Nascondini.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_2_EN9q629.jpg",
                    "products": [
                        {
                            "item_id": "cstm88845362",
                            "field1": "Passata di Pomodoro",
                            "field2": "Pomì",
                            "field3": "700 g",
                            "field4": "",
                            "description": "Passata di Pomodoro Pomì 700 g",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 2,
                            "quantity_step": 2,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 8.298988385162984,
                                "left": 4.872611464968153,
                                "width": 23.147558386411887,
                                "height": 32.685462720119894
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/pom_Fg1bYRp.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_FmJSaA1_yFqXEAu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.pomionline.it/it/prodotti/passate/passata-classica/700/"
                                }
                            ],
                            "related": ["cstm83312022"]
                        },
                        {
                            "item_id": "cstm98122012",
                            "field1": "Patatine",
                            "field2": "Amica Chips",
                            "field3": "300 g",
                            "field4": "",
                            "description": "Patatine Amica Chips 300 g",
                            "grammage": 300,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 40.98445110528288,
                                "left": 4.872611464968153,
                                "width": 23.147558386411887,
                                "height": 16.916448107905584
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/chips_NBbGl4Z.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_sykrAjn_ATeIzhx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75326148",
                            "field1": "Semola De Cecco",
                            "field2": "Rimacinata Grano",
                            "field3": "Duro o Integrale",
                            "field4": "1Kg",
                            "description": "Semola De Cecco Rimacinata Grano Duro o Integrale 1Kg",
                            "grammage": 1000,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Grano Duro",
                                "Integrale"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 57.90089921318845,
                                "left": 4.872611464968153,
                                "width": 23.147558386411887,
                                "height": 16.60266017234919
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/semola_FrKgU8X.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/semola_int_t4vaXdj.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_cJ3Dmmu_zGYw85S.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm25796361",
                            "field1": "Filetti di acciughe",
                            "field2": "sott'olio",
                            "field3": "80 g",
                            "field4": "",
                            "description": "Filetti di acciughe sott'olio 80 g",
                            "grammage": 80,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 74.50355938553764,
                                "left": 4.872611464968153,
                                "width": 23.14755838641189,
                                "height": 16.359123267141253
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_pAGMF5S_mvc50UB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm46827930",
                            "field1": "Bieta Erbetta",
                            "field2": "Carrefour",
                            "field3": "400 g",
                            "field4": "",
                            "description": "Bieta Erbetta Carrefour 400 g",
                            "grammage": 400,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 74.50355938553764,
                                "left": 28.02016985138004,
                                "width": 22.69108280254777,
                                "height": 16.359123267141253
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_BofqDYR_wMi3JpW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83312022",
                            "field1": "Pasta fresca all'uovo",
                            "field2": "Sfogliagrezza Rana",
                            "field3": "formati assortiti",
                            "field4": "250 g",
                            "description": "Pasta fresca all'uovo Sfogliagrezza Rana formati assortiti 250 g",
                            "grammage": 250,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Tagliatelle",
                                "Tagliolini",
                                "Fettuccine",
                                "Pappardelle",
                                "4 Cereali e Semi di Papavero"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 57.82128137879355,
                                "left": 28.02016985138004,
                                "width": 22.69108280254777,
                                "height": 16.682278006744095
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/tagliatelle_GHaEaAU.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/tagliolini_ECueOVd.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/fettuccine_nY9lbUQ.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/pappardelle_907GQZ9.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/papavero_S4Nu5zR.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_8B5KiZZ_HMUVIce.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Pasta fresca",
                                        "testo": "Il generoso formato di pasta fresca d’origine toscana è interpretato da Giovanni Rana. L’esclusiva Sfogliagrezza, preparata con uova extra fresche da galline allevate all’aperto. (Fonte: giovannirana.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/THFG3nyJd6/images/Pappardelle-250g-ITA-R551.png"
                                        ]
                                    }
                                }
                            ],
                            "related": ["cstm88845362"]
                        },
                        {
                            "item_id": "cstm32979149",
                            "field1": "Pasta sfoglia",
                            "field2": "Carrefour",
                            "field3": "rettangolare",
                            "field4": "230 g",
                            "description": "Pasta sfoglia Carrefour rettangolare 230 g",
                            "grammage": 230,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 41.064068939677774,
                                "left": 28.02016985138004,
                                "width": 22.69108280254777,
                                "height": 16.757212439115776
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_IEhbG04_61iOsY0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42409908",
                            "field1": "Yogurt intero",
                            "field2": "Vipiteno",
                            "field3": "gusti assortiti",
                            "field4": "250 g",
                            "description": "Yogurt intero Vipiteno gusti assortiti 250 g",
                            "grammage": 250,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 2,
                            "quantity_step": 2,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 24.063319595354063,
                                "left": 28.02016985138004,
                                "width": 22.69108280254777,
                                "height": 17.000749344323715
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/vipiteno_480nT9b.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_YcoiPb4_XOFcjea.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73738550",
                            "field1": "Barrette di cereali",
                            "field2": "Carrefourn",
                            "field3": "gusti assortiti",
                            "field4": "126 g",
                            "description": "Barrette di cereali Carrefourn gusti assortiti 126 g",
                            "grammage": 756,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cioccolato fondente",
                                "Mirtillo rosso",
                                "Cioccolato al latte e Uva passa"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 8.261521168977144,
                                "left": 28.02016985138004,
                                "width": 22.69108280254777,
                                "height": 15.801798426376921
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cioc2_XizTLdj.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cioccolato_ARx5Vey.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/mirtillo_C8hT86z.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_M1bFwvr_n9T950K.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm63876936",
                            "field1": "Linea Mikado",
                            "field2": "gusti assortiti",
                            "field3": "75 g",
                            "field4": "",
                            "description": "Linea Mikado gusti assortiti 75 g",
                            "grammage": 75,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cioccolato al latte",
                                "Cioccolato fondente",
                                "Cioccolato bianco"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 8.341139003372048,
                                "left": 50.97133757961784,
                                "width": 23.412951167728234,
                                "height": 15.88141626077182
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cioccolato.webp_izjSGQf.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/latte_JU6iuqi.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/bianco_KRkAx0a.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_9aWpVmd_k9NioZe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Mikado.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70356735",
                            "field1": "Parmigiano Reggiano DOP",
                            "field2": "Parmareggio",
                            "field3": "grattugiato",
                            "field4": "60 g",
                            "description": "Parmigiano Reggiano DOP Parmareggio grattugiato 60 g",
                            "grammage": 60,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 24.222555264143868,
                                "left": 50.97133757961784,
                                "width": 23.412951167728234,
                                "height": 16.921131509928813
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/parmiggiano_GAufrFY.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_wWnXjIq_zIfrqxZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/SPOT_IL_GRATTUGIATO_PARMAREGGIO.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93589310",
                            "field1": "Formaggio fuso a fette",
                            "field2": "Carrefour",
                            "field3": "200 g",
                            "field4": "",
                            "description": "Formaggio fuso a fette Carrefour 200 g",
                            "grammage": 200,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 41.143686774072684,
                                "left": 50.97133757961784,
                                "width": 23.412951167728234,
                                "height": 16.75721243911577
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_9Jp3AAy_KwSzc3I.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm89731073",
                            "field1": "Hamburger Amadori",
                            "field2": "conf 2 pezzi",
                            "field3": "da 80 g cad",
                            "field4": "160 g",
                            "description": "Hamburger Amadori conf 2 pezzi da 80 g cad 160 g",
                            "grammage": 160,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 57.90089921318845,
                                "left": 50.97133757961784,
                                "width": 23.412951167728234,
                                "height": 16.761895841139005
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/hamburger_Yx0UeqE.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_L0A5GTN_9mHqB9l.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm71121480",
                            "field1": "Cuori di Iceberg",
                            "field2": "Il Mercato",
                            "field3": "Carrefour",
                            "field4": "250 g",
                            "description": "Cuori di Iceberg Il Mercato Carrefour 250 g",
                            "grammage": 250,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 74.66279505432746,
                                "left": 50.97133757961784,
                                "width": 23.412951167728234,
                                "height": 16.199887598351438
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_n67UN13_XKn2r8z.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm72095191",
                            "field1": "Piante Aromatiche",
                            "field2": "Basilico, salvia,",
                            "field3": "rosmarino o menta",
                            "field4": "vaso 14 cm",
                            "description": "Piante Aromatiche Basilico, salvia, rosmarino o menta vaso 14 cm",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosmarino",
                                "Menta"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 74.66279505432746,
                                "left": 74.38428874734609,
                                "width": 25.615711252653924,
                                "height": 16.199887598351438
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_glmx3vs_7ZCRw3A.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24568223",
                            "field1": "Olive verdi",
                            "field2": "Carrefour",
                            "field3": "denocciolate o intere",
                            "field4": "350 g",
                            "description": "Olive verdi Carrefour denocciolate o intere 350 g",
                            "grammage": 350,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Denocciolate",
                                "Intere"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.06013488197827,
                                "left": 74.38428874734606,
                                "width": 25.615711252653924,
                                "height": 16.602660172349196
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/olive_3KVR08q.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/olive_intere_0WUjP43.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_BaIocjf_speqc1m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm22901851",
                            "field1": "Kinder Cioccolato",
                            "field2": "conf 8 pezzi",
                            "field3": "100 g",
                            "field4": "",
                            "description": "Kinder Cioccolato conf 8 pezzi 100 g",
                            "grammage": 100,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 8.18190333458224,
                                "left": 74.38428874734606,
                                "width": 25.615711252653924,
                                "height": 16.43874110153616
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/kinder_tsdbHlI.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_dDX12rJ_cJpDqEy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_3_0esDpeW.jpg",
                    "products": [
                        {
                            "item_id": "cstm88674337",
                            "field1": "Brodo liquido",
                            "field2": "Knorr",
                            "field3": "gusti assortiti",
                            "field4": "750 ml",
                            "description": "Brodo liquido Knorr gusti assortiti 750 ml",
                            "grammage": 750,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Manzo",
                                "Vegetale",
                                "Carne mista"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 8.261521168977144,
                                "left": 0.0,
                                "width": 25.615711252653924,
                                "height": 16.43874110153616
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/manzo_Dbhi8Yd.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/vegetale_uEC6Io1.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/mista_8hMeLfy.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_CemY3sM_Qa7fdeN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59541980",
                            "field1": "Acqua Levissima",
                            "field2": "naturale o frizzante",
                            "field3": "con 6 pezzi da 500 ml cad",
                            "field4": "3 lt",
                            "description": "Acqua Levissima naturale o frizzante con 6 pezzi da 500 ml cad 3 lt",
                            "grammage": 3000,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Naturale",
                                "Frizzante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 8.261521168977144,
                                "left": 25.615711252653924,
                                "width": 23.65180467091296,
                                "height": 16.43874110153616
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/naturale_n9vopcZ.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/frizzante_uRjPVG3.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_x6yqH7y_2xRmqFn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00059783",
                            "field1": "Donna Barbara",
                            "field2": "bianco, rosso o rosato",
                            "field3": "750 ml",
                            "field4": "",
                            "description": "Donna Barbara bianco, rosso o rosato 750 ml",
                            "grammage": 750,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Rosso",
                                "Rosato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 24.7002622705133,
                                "left": 25.615711252653924,
                                "width": 23.65180467091296,
                                "height": 16.44342450355938
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/bianco_65zhuH2_azAJilg.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/rosso_Et98zTD.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/rosato_WEJmDwv.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_yUxkGHq_siuNkps.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm00977835"]
                        },
                        {
                            "item_id": "cstm89661627",
                            "field1": "Assorbenti Lines Idea",
                            "field2": "Liberty con 15 pezzi Ali con 14 pezzi",
                            "field3": "Ultra giorno conf 12 pezzi",
                            "field4": "Ultra notte con 10 pezzi",
                            "description": "Assorbenti Lines Idea Liberty con 15 pezzi Ali con 14 pezzi Ultra giorno conf 12 pezzi Ultra notte con 10 pezzi",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Liberty 15 pz",
                                "Ali 14 pz",
                                "Ultra giorno 12 pz",
                                "Ultra notte 10 pz"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 41.143686774072684,
                                "left": 25.615711252653924,
                                "width": 23.65180467091296,
                                "height": 16.916448107905584
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/notte_WP6xdq8.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/giorno_c9f6wTR.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/liberty_nAqqtM1.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/ali_BdRCBn3.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_HYqvqJD_K46Epjy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm44242930",
                            "field1": "Carta forno",
                            "field2": "Domopak",
                            "field3": "8 mt",
                            "field4": "",
                            "description": "Carta forno Domopak 8 mt",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 58.06013488197827,
                                "left": 25.615711252653924,
                                "width": 23.65180467091296,
                                "height": 16.682278006744095
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/carta_forno_lHD93yf.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_XBV4dgz_HJbyPhF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm89479758", "cstm13547009", "cstm76923690"]
                        },
                        {
                            "item_id": "cstm89479758",
                            "field1": "Sacchetti gelo",
                            "field2": "Domopak",
                            "field3": "misure e forme assortite",
                            "field4": "",
                            "description": "Sacchetti gelo Domopak misure e forme assortite",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Piccoli",
                                "Medi",
                                "Grandi"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 58.06013488197827,
                                "left": 0.0,
                                "width": 25.615711252653924,
                                "height": 16.682278006744095
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/piccoli_zDZQTZk.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/medi_KUoWBg2.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/grandi_eU6XmhK.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_wEXlXDn_mQ3ZAOF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm44242930", "cstm13547009", "cstm76923690"]
                        },
                        {
                            "item_id": "cstm13547009",
                            "field1": "Alluminio",
                            "field2": "Domopak",
                            "field3": "8 mt",
                            "field4": "",
                            "description": "Alluminio Domopak 8 mt",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 58.06013488197827,
                                "left": 49.61783439490445,
                                "width": 22.839702760084933,
                                "height": 16.682278006744095
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/alluminio_wemSyJr.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_aUMvv7q_SCZ9EaW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm89479758", "cstm44242930", "cstm76923690"]
                        },
                        {
                            "item_id": "cstm76923690",
                            "field1": "Vaschette",
                            "field2": "Domopak",
                            "field3": "misure e forme assortite",
                            "field4": "",
                            "description": "Vaschette Domopak misure e forme assortite",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "8 porzioni - 2 vaschette",
                                "4 porzioni - 4 vaschette",
                                "6 porzioni - 2 vaschette",
                                "Tonda 8 porzioni - 3 vaschette",
                                "1 porzioni - 12 vaschette"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 58.06013488197827,
                                "left": 72.4575371549894,
                                "width": 27.542462845010597,
                                "height": 16.682278006744095
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/1_12_sWNSRGh.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/4_4_HaeVgtF.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/6_2_OYZJuRU.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/8_2_sLcG20H.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/8_3_Vtn3FYS.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_nIDwnYf_T3PjSJg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm89479758", "cstm44242930", "cstm13547009"]
                        },
                        {
                            "item_id": "cstm55601953",
                            "field1": "Terrine Delizia Patè per gatti",
                            "field2": "Carrefour",
                            "field3": "con 4 pezzi da 100 g cad",
                            "field4": "400 g",
                            "description": "Terrine Delizia Patè per gatti Carrefour con 4 pezzi da 100 g cad 400 g",
                            "grammage": 400,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 74.74241288872237,
                                "left": 72.4575371549894,
                                "width": 27.542462845010597,
                                "height": 16.12026976395654
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_zjLFJow_DZrr9CT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35832269",
                            "field1": "Profumatori auto",
                            "field2": "Fresca foglia",
                            "field3": "Arexons",
                            "field4": "",
                            "description": "Profumatori auto Fresca foglia Arexons",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Vaniglia",
                                "Ocean",
                                "Pino",
                                "Uomo",
                                "Donna",
                                "Lavanda",
                                "Lime",
                                "Tropical",
                                "Fresca aria neutralizza fumo",
                                "Frutti di bosco",
                                "New Car"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Auto&Moto",
                            "subcategory": "Cura auto&moto",
                            "blueprint": {
                                "top": 74.74241288872237,
                                "left": 49.55944798301485,
                                "width": 22.898089171974544,
                                "height": 16.12026976395654
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/bosco_VAZBgm4.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/donna_KXBMG9Y.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/fumo_ySLxzQU.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/lavanda_vJOpwNZ.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/lime_BAhKYPH.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/new_9wFaNiN.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/ocean_pgG8eIV.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/pino_OaLpj7T.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/tropical_pHtay5X.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/uomo_ZEtOPCN.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Vaniglia_3lzGpnQ.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_5BLUxoL_yfRWkyA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm05471766",
                            "field1": "Adattatore con Spina 10A",
                            "field2": "presa 10-16A",
                            "field3": "",
                            "field4": "",
                            "description": "Adattatore con Spina 10A presa 10-16A",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 74.74241288872237,
                                "left": 26.077494692144384,
                                "width": 23.481953290870468,
                                "height": 16.12026976395654
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_cfdc2My_cz5dP2e.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09233512",
                            "field1": "Bottifglia in vetro",
                            "field2": "liscia o a coste",
                            "field3": "1 lt",
                            "field4": "",
                            "description": "Bottifglia in vetro liscia o a coste 1 lt",
                            "grammage": 1000,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "A coste",
                                "Liscia"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 74.82203072311727,
                                "left": 0.0,
                                "width": 25.39808917197452,
                                "height": 16.120269763956536
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/coste_lL9nicT.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/liscia_p3VD2O2.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_8ZK1Fa3_PzrGDkf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm98233607",
                            "field1": "Birra Peroni",
                            "field2": "Cruda",
                            "field3": "500 ml",
                            "field4": "",
                            "description": "Birra Peroni Cruda 500 ml",
                            "grammage": 500,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 8.20063694267516,
                                "left": 49.23301486199575,
                                "width": 22.738853503184714,
                                "height": 15.92356687898089
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cruda_JtKViAJ.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_FF9JIjz_4L77tOs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Peroni_Cruda_30.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00977835",
                            "field1": "Sangiovese IGT",
                            "field2": "Il Feudo",
                            "field3": "750 ml",
                            "field4": "",
                            "description": "Sangiovese IGT Il Feudo 750 ml",
                            "grammage": 750,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 24.124203821656053,
                                "left": 49.23301486199575,
                                "width": 22.738853503184714,
                                "height": 17.117834394904456
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/vino_92EmWhR.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_FGvPzij_NxjGFeT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm00059783"]
                        },
                        {
                            "item_id": "cstm47716740",
                            "field1": "Box Veline",
                            "field2": "Tempo",
                            "field3": "Light",
                            "field4": "conf 60 veline",
                            "description": "Box Veline Tempo Light conf 60 veline",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 41.242038216560495,
                                "left": 49.23301486199575,
                                "width": 22.738853503184714,
                                "height": 17.038216560509554
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/box_LYtsu1i.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_SblLU0x_9scauXU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Tempo.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65296706",
                            "field1": "Tovagliolo monovelo",
                            "field2": "30x30",
                            "field3": "conf 200 pezzi",
                            "field4": "",
                            "description": "Tovagliolo monovelo 30x30 conf 200 pezzi",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 41.2420382165605,
                                "left": 71.97186836518047,
                                "width": 28.028131634819523,
                                "height": 17.038216560509554
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_UzWHuwN_lVx8hRM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm81184914",
                            "field1": "Sapone Mani",
                            "field2": "Fresh & Clean",
                            "field3": "profumazioni assortite",
                            "field4": "300 ml",
                            "description": "Sapone Mani Fresh & Clean profumazioni assortite 300 ml",
                            "grammage": 300,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 24.20382165605096,
                                "left": 71.97186836518047,
                                "width": 28.028131634819523,
                                "height": 17.038216560509554
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_t0AVoZZ_qufuUvi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm46397035",
                            "field1": "Vino Carrefour",
                            "field2": "bianco, rosso, o rosato",
                            "field3": "in brick",
                            "field4": "1 lt",
                            "description": "Vino Carrefour bianco, rosso, o rosato in brick 1 lt",
                            "grammage": 1000,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Rosso",
                                "Rosato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 8.359872611464967,
                                "left": 71.97186836518047,
                                "width": 28.028131634819523,
                                "height": 15.843949044585987
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/c_bianco_GfQnEZ8.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/c_rosato_kBFmqXF.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/c_rosso_GoOA59k.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_yCT56bM_zNvsHWj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_4_WVRu6Cx.jpg",
                    "products": [
                        {
                            "item_id": "cstm24539929",
                            "field1": "Prosciutto Crudo",
                            "field2": "Carrefour Classic",
                            "field3": "100 g",
                            "field4": "",
                            "description": "Prosciutto Crudo Carrefour Classic 100 g",
                            "grammage": 100,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 8.261521168977144,
                                "left": 0.0,
                                "width": 27.47346072186836,
                                "height": 15.88141626077182
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/crudo_VEuFBsI.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_3UEVtTB_Z30PKiT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm98898192",
                            "field1": "Pasta di semola",
                            "field2": "di grano duro",
                            "field3": "Rummo",
                            "field4": "formati assortiti 500 g",
                            "description": "Pasta di semola di grano duro Rummo formati assortiti 500 g",
                            "grammage": 500,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 3,
                            "quantity_step": 3,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 24.264705882352935,
                                "left": 0.0,
                                "width": 27.292993630573246,
                                "height": 33.79542899962532
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_yJhuqU0_mwwFGGd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm41302653",
                            "field1": "Riso Basmati",
                            "field2": "o Arborio",
                            "field3": "Gallo",
                            "field4": "1 kg",
                            "description": "Riso Basmati o Arborio Gallo 1 kg",
                            "grammage": 1000,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.06013488197827,
                                "left": 0.0,
                                "width": 27.292993630573246,
                                "height": 16.602660172349196
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/basmati_AMzGgDR.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/arborio_ePlJkn2.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_emTqm2K_GSNISCB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm50547898",
                            "field1": "Capsule caffè",
                            "field2": "Carrefour Selection",
                            "field3": "compatibili Nespresso",
                            "field4": "11 caps",
                            "description": "Capsule caffè Carrefour Selection compatibili Nespresso 11 caps",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 74.66279505432746,
                                "left": 0.0,
                                "width": 27.292993630573246,
                                "height": 16.199887598351438
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_pPfQNII_LttICXh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm47505787",
                            "field1": "Wafer Loacker",
                            "field2": "gusti assortiti",
                            "field3": "conf 5 pezzi",
                            "field4": "225 g",
                            "description": "Wafer Loacker gusti assortiti conf 5 pezzi 225 g",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 74.66279505432746,
                                "left": 27.292993630573246,
                                "width": 24.140127388535035,
                                "height": 16.199887598351438
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/wafer._6ndfjBz.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_jFNRlCz_ArDEEJ9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Loacker___Wafer.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm71010437",
                            "field1": "Sofficini findus",
                            "field2": "gusti assortiti",
                            "field3": "conf 4 pezzi",
                            "field4": "266 g",
                            "description": "Sofficini findus gusti assortiti conf 4 pezzi 266 g",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 57.82128137879355,
                                "left": 27.292993630573246,
                                "width": 24.140127388535035,
                                "height": 16.84151367553391
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/sofficini_7zfHbHf.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_LySrLrV_at6BtZr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Spot_Carletto_nuovi_Sofficini_Extra_Croccanti_anche_al_forno_-_Spot_2015.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51092471",
                            "field1": "Nobile",
                            "field2": "Italiano",
                            "field3": "spicchio",
                            "field4": "250 g",
                            "description": "Nobile Italiano spicchio 250 g",
                            "grammage": 250,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 41.143686774072684,
                                "left": 27.292993630573246,
                                "width": 24.140127388535035,
                                "height": 16.677594604720866
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_AAIQy1A_Nd0ojPq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91539437",
                            "field1": "Salsa Messicana hot",
                            "field2": "Carrefour",
                            "field3": "315 g",
                            "field4": "",
                            "description": "Salsa Messicana hot Carrefour 315 g",
                            "grammage": 315,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 24.063319595354063,
                                "left": 27.292993630573246,
                                "width": 24.140127388535035,
                                "height": 17.080367178718625
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_yRqTQV3_AgAh2Ut.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17830705",
                            "field1": "Speck",
                            "field2": "80 g",
                            "field3": "",
                            "field4": "",
                            "description": "Speck 80 g",
                            "grammage": 80,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 8.18190333458224,
                                "left": 27.292993630573246,
                                "width": 24.140127388535035,
                                "height": 15.88141626077182
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_eltA5kI_zYfoVdx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm16716090",
                            "field1": "Cubetti di Pancetta Negroni",
                            "field2": "dolce o affumicata",
                            "field3": "conf 2 pezzi da 80 g cad",
                            "field4": "160 g",
                            "description": "Cubetti di Pancetta Negroni dolce o affumicata conf 2 pezzi da 80 g cad 160 g",
                            "grammage": 160,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Dolce",
                                "Affumicata"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 8.18190333458224,
                                "left": 51.43312101910826,
                                "width": 22.78131634819532,
                                "height": 15.88141626077182
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_oqVlKYf_c39OmDw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.negroni.com/it/prodotti/salumi-cubetti/pancetta-affumicata"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm90066494",
                            "field1": "Flour Tortillas",
                            "field2": "Old el Paso",
                            "field3": "326 g",
                            "field4": "",
                            "description": "Flour Tortillas Old el Paso 326 g",
                            "grammage": 326,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 24.063319595354063,
                                "left": 51.43312101910826,
                                "width": 22.78131634819532,
                                "height": 16.921131509928813
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/tortillas_QhAycqw.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_blTwdpv_v4ZKtGr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm81351241",
                            "field1": "Mozzarella",
                            "field2": "Carrefour",
                            "field3": "per pizza",
                            "field4": "400 g",
                            "description": "Mozzarella Carrefour per pizza 400 g",
                            "grammage": 400,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 40.98445110528288,
                                "left": 51.43312101910826,
                                "width": 22.78131634819532,
                                "height": 17.07568377669539
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/moz_hRKgbCr.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_T7rprjX_uAdAEWh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51312014",
                            "field1": "Olive Verdi Giganti",
                            "field2": "500 g",
                            "field3": "",
                            "field4": "",
                            "description": "Olive Verdi Giganti 500 g",
                            "grammage": 500,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.06013488197827,
                                "left": 51.43312101910826,
                                "width": 22.781316348195322,
                                "height": 16.602660172349196
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_aypTPNt_4TJtI3z.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm27279742",
                            "field1": "Tavoletta",
                            "field2": "M&M's",
                            "field3": "gusti assortiti",
                            "field4": "150 g",
                            "description": "Tavoletta M&M's gusti assortiti 150 g",
                            "grammage": 150,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Peanut",
                                "Crispy",
                                "Chocolate",
                                "Hazelnut"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 74.66279505432746,
                                "left": 51.43312101910826,
                                "width": 22.78131634819532,
                                "height": 16.279505432746344
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/m_1_h5dLrpb.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/m_22_VFo4hi2.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/m_3_BnqSuDV.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/m_4_k5TkYJp.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_IGYBy5K_wFQKTMS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93886176",
                            "field1": "Coni",
                            "field2": "Carrefour",
                            "field3": "conf 6 pezzi",
                            "field4": "420 g",
                            "description": "Coni Carrefour conf 6 pezzi 420 g",
                            "grammage": 420,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 74.66279505432746,
                                "left": 74.21443736730359,
                                "width": 25.785562632696397,
                                "height": 16.279505432746344
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_IRuVIRw_bdWRaxP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11050921",
                            "field1": "Linea Benessere",
                            "field2": "BB Mix",
                            "field3": "Ventura",
                            "field4": "150 g",
                            "description": "Linea Benessere BB Mix Ventura 150 g",
                            "grammage": 150,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Benessere",
                                "Bellezza",
                                "Multivit",
                                "Sprint",
                                "Fibra",
                                "Focus",
                                "Macedonie / yogurt / gelati"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 57.90089921318845,
                                "left": 74.21443736730359,
                                "width": 25.785562632696397,
                                "height": 16.761895841139005
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/1_UW6UYkH.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/2_7xSwoUo.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/3_nZGbgLV.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/4_X023pGE.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/5_16I3H51.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/6_MnGcjm8.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/7_T3zjIyX.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_m2ZmTO6_xRuqtIa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78364685",
                            "field1": "Frittate Prosciutto e",
                            "field2": "Formaggio Aia",
                            "field3": "",
                            "field4": "",
                            "description": "Frittate Prosciutto e Formaggio Aia",
                            "grammage": 180,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Piatti Pronti",
                            "blueprint": {
                                "top": 8.21937055076808,
                                "left": 74.21443736730359,
                                "width": 25.785562632696397,
                                "height": 16.36380666916448
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/frittata_PcMjn7V.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_hIrTTwH_mhqRVl1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_5_Ew0VKD0.jpg",
                    "products": [
                        {
                            "item_id": "cstm13336537",
                            "field1": "Birra ichnusa",
                            "field2": "con 3 pezzi da 330 ml",
                            "field3": "",
                            "field4": "",
                            "description": "Birra ichnusa con 3 pezzi da 330 ml",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 8.355875861326442,
                                "left": 0.0,
                                "width": 25.62129898794143,
                                "height": 15.611541774332471
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/ICHNUSACL33X3-8006890325133-1_GMqSTUS.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_DcC6c84_pgPUJPJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Ichnusa.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91277410",
                            "field1": "Montepulciano o Trebbiano",
                            "field2": "d'abbruzzo doc",
                            "field3": "la calenzata",
                            "field4": "",
                            "description": "Montepulciano o Trebbiano d'abbruzzo doc la calenzata",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Montepulciano",
                                "Trebbiano"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 8.355875861326442,
                                "left": 25.62129898794143,
                                "width": 21.966986972437546,
                                "height": 15.611541774332471
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_deonFY7_47O9eSz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73071200",
                            "field1": "Vermentino igt",
                            "field2": "Terre siciliane",
                            "field3": "le morre",
                            "field4": "",
                            "description": "Vermentino igt Terre siciliane le morre",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 8.355875861326442,
                                "left": 47.58828596037898,
                                "width": 24.6451290195234,
                                "height": 15.611541774332471
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_dowvXDC_JPVFKY0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33395173",
                            "field1": "Alimento per gatti",
                            "field2": "gourmet perle trionfo di slasa",
                            "field3": "gusti assortiti",
                            "field4": "conf 4 buste da 85g",
                            "description": "Alimento per gatti gourmet perle trionfo di slasa gusti assortiti conf 4 buste da 85g",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Manzo e pollo",
                                "Salmone e tonno"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 8.355875861326442,
                                "left": 72.23341497990238,
                                "width": 25.2615606158484,
                                "height": 15.611541774332471
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/GOURMETPERLESALSATONNOX4-7613036140256-1_jUmFmM5.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/GOURMETPERLESALSAX4-7613036142908-1_uRj9K69.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_zvhXdAD_3K9RL6h.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78012122",
                            "field1": "johnson's baby",
                            "field2": "shampoo/ shampoo dolci notti",
                            "field3": "300 ml",
                            "field4": "",
                            "description": "johnson's baby shampoo/ shampoo dolci notti 300 ml",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Shampoo",
                                "Shampoo dolci notti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 24.39808085701981,
                                "left": 72.23341497990238,
                                "width": 25.2615606158484,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/SHAMPOOGOLDBABYJOHNSON-3574669907538-1_V3240oL.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_SWGhCxp_7QMnojA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Johnsons",
                                        "testo": "La pelle dei neonati è la più delicata. Ecco perché in più di 125 anni abbiamo perfezionato le nostre formule, adesso ancora più delicate per tutti. JOHNSON’S® Baby Shampoo è basato sulla nostra formula più leggera ed è stato appositamente ideato per detergere dolcemente i capelli fini e il delicato cuoio capelluto del bambino. Si massaggia velocemente ed è facile da risciacquare lasciando i capelli del bambino morbidi, lucenti, facili da pettinare e puliti. Ideale sia per i bambini che per gli adulti! (Fonte: johnsonsbaby.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/THFG3nyJd6/images/SHAMPOOGOLDBABYJOHNSON-3574669907538-1_V3240oL.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm52435877",
                            "field1": "Maschera rigenerante",
                            "field2": "capelli",
                            "field3": "mil mil",
                            "field4": "assortite lt.1",
                            "description": "Maschera rigenerante capelli mil mil assortite lt.1",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Capelli",
                            "blueprint": {
                                "top": 24.39808085701981,
                                "left": 49.418604651162795,
                                "width": 22.814810328739593,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/71BqsS9jwYL._AC_SX679__zGizuHe.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_gF2qJ36_Mefz8xT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01228431",
                            "field1": "Docciaschiuma",
                            "field2": "Borotalco",
                            "field3": "profumazioni assortite",
                            "field4": "200 ml",
                            "description": "Docciaschiuma Borotalco profumazioni assortite 200 ml",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Borotalco",
                                "Mandarino e neroli",
                                "Sali marini",
                                "Cedro e lime"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 24.39808085701981,
                                "left": 25.62129898794143,
                                "width": 23.797305663221355,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/DOCCIASCHIUMAORIGINALBOROTAL-8002410044133-1_KX9pJrP.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/DOCCIAACTIVEARANCBOROTALCO-8002410044126-1_bzX5nvA.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/DOCCIAACTIVEBLUBOROTALCO-8002410044119-1_nNZLgTY.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/DOCCIAACTIVEGIALLOBOROTALCO-8002410044102-1_SECeRFy.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_2dKJFsR_8TzYI9K.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Borotalco",
                                        "testo": "Da Borotalco nasce la nuova doccia profumo Original, formulata con un concentrato di inconfondibile essenza di Borotalco. Grazie al profumo potenziato del +50%*, in doccia sei subito avvolto da maggior profumo che permane più a lungo*, per una pelle morbida e profumata. (Fonte: borotalco.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/THFG3nyJd6/images/DOCCIASCHIUMAORIGINALBOROTAL-8002410044133-1_KX9pJrP.webp"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm72113882",
                            "field1": "Carta igienica compatta",
                            "field2": "ecoplanet",
                            "field3": "carrefour",
                            "field4": "conf 4 pezzi",
                            "description": "Carta igienica compatta ecoplanet carrefour conf 4 pezzi",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 41.19394649009474,
                                "left": 25.62129898794143,
                                "width": 23.797305663221355,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/CARTAIGMAXIECOPLANETX4CRF-3560070818655-1_i7WuqaM.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_YjzG14o_7rdhlFD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm16835980",
                            "field1": "Bicchiere acqua",
                            "field2": "cl.30",
                            "field3": "",
                            "field4": "",
                            "description": "Bicchiere acqua cl.30",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 6,
                            "quantity_step": 6,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.98981212316967,
                                "left": 0.0,
                                "width": 25.62129898794143,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_Pk7hcFQ_9D9xtKY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60425527",
                            "field1": "Tovagliette usa e getta",
                            "field2": "nickly limone",
                            "field3": "60 pezzi",
                            "field4": "",
                            "description": "Tovagliette usa e getta nickly limone 60 pezzi",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 41.08628068475451,
                                "left": 48.93051966695378,
                                "width": 24.27906528136664,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_PCRI9cN_gRJxNdy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49598404",
                            "field1": "Bacinelle",
                            "field2": "rettangolari/ tonde/ con becco",
                            "field3": "grigio/ rosso/ blu",
                            "field4": "",
                            "description": "Bacinelle rettangolari/ tonde/ con becco grigio/ rosso/ blu",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rettangolari grigio",
                                "Rettangolari rosso",
                                "Rettangolari blu",
                                "Tonde grigio",
                                "Tonde rosso",
                                "Tonde blu",
                                "Con becco grigio",
                                "Con becco rosso",
                                "Con becco blu"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 41.08628068475451,
                                "left": 73.20958494832041,
                                "width": 24.529433139534873,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_793MV8v_NeH7DS9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm43915141",
                            "field1": "contenitore per alimenti",
                            "field2": "in vetro borosilicato",
                            "field3": "900 ml",
                            "field4": "",
                            "description": "contenitore per alimenti in vetro borosilicato 900 ml",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.88214631782946,
                                "left": 73.20958494832041,
                                "width": 24.529433139534873,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_Mc87zqr_syW6vTL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm47075400",
                            "field1": "Piatti in polpa di cellulosa",
                            "field2": "biodegradabili e compostabili",
                            "field3": "bido",
                            "field4": "conf 15 pezzi",
                            "description": "Piatti in polpa di cellulosa biodegradabili e compostabili bido conf 15 pezzi",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.88214631782946,
                                "left": 49.05254091300603,
                                "width": 24.157044035314385,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_D32nQF8_qCIvJJm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm95569910",
                            "field1": "Bicchieri in cartoncino",
                            "field2": "250 ml",
                            "field3": "conf 25 pezzi",
                            "field4": "",
                            "description": "Bicchieri in cartoncino 250 ml conf 25 pezzi",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.88214631782946,
                                "left": 25.987362726098194,
                                "width": 23.065178186907833,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_Y1w0YIq_H32M8Tx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92660766",
                            "field1": "Set 5 panni",
                            "field2": "in microfibra",
                            "field3": "",
                            "field4": "",
                            "description": "Set 5 panni in microfibra",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 74.89334356158484,
                                "left": 0.24404249210450757,
                                "width": 25.743320233993686,
                                "height": 15.93453919035314
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_EKCuDvY_6xpB4t1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm20865916",
                            "field1": "Set 2 pezzi",
                            "field2": "mascherine in cotone",
                            "field3": "lavabili e riutilizzabili",
                            "field4": "fantasie assortite",
                            "description": "Set 2 pezzi mascherine in cotone lavabili e riutilizzabili fantasie assortite",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 74.89334356158484,
                                "left": 25.987362726098194,
                                "width": 24.163369401378112,
                                "height": 15.93453919035314
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_0wFT0DA_w9R0QJw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06579068",
                            "field1": "Federa Tex",
                            "field2": "100% cotone",
                            "field3": "57 fili",
                            "field4": "",
                            "description": "Federa Tex 100% cotone 57 fili",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 74.89334356158484,
                                "left": 50.15073212747631,
                                "width": 22.448746590582832,
                                "height": 15.93453919035314
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_97i5d0A_fbYyNyY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26370558",
                            "field1": "Pantofole uomo o donna",
                            "field2": "in spugna",
                            "field3": "tinta unita",
                            "field4": "colori assortiti",
                            "description": "Pantofole uomo o donna in spugna tinta unita colori assortiti",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Uomo",
                                "Donna"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Abbigliamento",
                            "subcategory": "Scarpe",
                            "blueprint": {
                                "top": 74.89334356158484,
                                "left": 72.59947871805915,
                                "width": 22.211029464542055,
                                "height": 15.93453919035314
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_u92vg7d_PTCJy5S.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_6_YODpCQS.jpg",
                    "products": [
                        {
                            "item_id": "cstm29286494",
                            "field1": "Cozze cotte",
                            "field2": "alla marinara",
                            "field3": "angulas aguinaga",
                            "field4": "500g",
                            "description": "Cozze cotte alla marinara angulas aguinaga 500g",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 8.140544250645995,
                                "left": 27.45161767872524,
                                "width": 23.91616422624174,
                                "height": 16.14987080103359
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_dajqN0o.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_39JiCdy_zN49mcH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm22492505",
                            "field1": "Filetti di salmone",
                            "field2": "as do mar",
                            "field3": "all'olio di oliva o naturale",
                            "field4": "150g",
                            "description": "Filetti di salmone as do mar all'olio di oliva o naturale 150g",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Olio di oliva",
                                "Naturale"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 8.140544250645995,
                                "left": 51.367781904966975,
                                "width": 23.428079242032727,
                                "height": 16.14987080103359
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/SALMONEOOASDOMAR-8003294537001-1_xHizJDD.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_co5oGhG_GUoDJ4f.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.asdomar.it/prodotti/salmone/filetti-di-salmone-allolio-di-oliva/"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99701160",
                            "field1": "Miele millefiori",
                            "field2": "carrefour",
                            "field3": "500g",
                            "field4": "",
                            "description": "Miele millefiori carrefour 500g",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 8.140544250645995,
                                "left": 74.7958611469997,
                                "width": 24.892334194659774,
                                "height": 16.14987080103359
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/MIELEMILLEFIORICRF-8012666008025-1_Ud9Fuw0.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_DPSADfT_LGbikXQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm52548664",
                            "field1": "Arachidi",
                            "field2": "cameo",
                            "field3": "in busta 500g",
                            "field4": "",
                            "description": "Arachidi cameo in busta 500g",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 24.290415051679584,
                                "left": 74.7958611469997,
                                "width": 24.892334194659774,
                                "height": 16.580534022394488
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/CAMEOBUSTEARACHIDIGR500-8003000031205-1_zgiceVU.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_fvkfiIC_OClV2PG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19627920",
                            "field1": "Mele golden",
                            "field2": "melina",
                            "field3": "cassetta 3 kg",
                            "field4": "",
                            "description": "Mele golden melina cassetta 3 kg",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "cassetta",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 24.290415051679584,
                                "left": 51.48980315101923,
                                "width": 23.306057995980474,
                                "height": 16.580534022394488
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/MELEGOLDENMELINDAKG3-8004381104472-1_Hsg53vx.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_z1GzGop_MG2Sl3y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm68206798",
                            "field1": "Prosciutto crudo",
                            "field2": "110g",
                            "field3": "",
                            "field4": "",
                            "description": "Prosciutto crudo 110g",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 24.290415051679584,
                                "left": 28.18374515503876,
                                "width": 23.306057995980474,
                                "height": 16.580534022394488
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_NJPQpTd_Tqbx0wX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59005231",
                            "field1": "Linea cotti",
                            "field2": "amadori",
                            "field3": "280g",
                            "field4": "",
                            "description": "Linea cotti amadori 280g",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Carne",
                            "blueprint": {
                                "top": 24.290415051679584,
                                "left": 3.6574746985357485,
                                "width": 24.526270456503006,
                                "height": 16.580534022394488
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_1_UW0kYik.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_fAwGtYr_J2XExTC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42485990",
                            "field1": "Muller thurgau",
                            "field2": "venezie igt martellozzo",
                            "field3": "fermo o frizzante",
                            "field4": "750 ml",
                            "description": "Muller thurgau venezie igt martellozzo fermo o frizzante 750 ml",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fermo",
                                "Frizzante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 40.87094907407407,
                                "left": 3.6574746985357485,
                                "width": 24.526270456503006,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_5Jm9jsk_JNNxc7V.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77055671",
                            "field1": "Nero d'avola,",
                            "field2": "Grillo o Syrah igt",
                            "field3": "siciliane rialto dei vespi",
                            "field4": "750 ml",
                            "description": "Nero d'avola, Grillo o Syrah igt siciliane rialto dei vespi 750 ml",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Nero d'avola",
                                "Syrah",
                                "Grillo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 40.87094907407407,
                                "left": 28.18374515503876,
                                "width": 23.306057995980474,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_3x7GXdy_WmApQM0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm78977809",
                            "field1": "Coca cola, fanta o sprite",
                            "field2": "gusti assortiti",
                            "field3": "conf 4 pezzi da 660ml",
                            "field4": "",
                            "description": "Coca cola, fanta o sprite gusti assortiti conf 4 pezzi da 660ml",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Coca cola",
                                "Fanta",
                                "Sprite"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 40.87094907407407,
                                "left": 51.48980315101923,
                                "width": 23.184036749928215,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_3_b6GsS3V.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_2_KI5PNz1.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_SwAAxik_znRF7UF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Coca-Cola_presenta_Come_Mai_Prima_con_George_the_Poet.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm89249444",
                            "field1": "Carbonella di legna",
                            "field2": "carrefour",
                            "field3": "2,5 kg",
                            "field4": "",
                            "description": "Carbonella di legna carrefour 2,5 kg",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 40.87094907407407,
                                "left": 74.67383990094746,
                                "width": 24.038185472294003,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_cISrWxy_w5o0L9o.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm20607483",
                            "field1": "Crema viso idratante",
                            "field2": "hydra basic clinians",
                            "field3": "assortite 50ml",
                            "field4": "",
                            "description": "Crema viso idratante hydra basic clinians assortite 50ml",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 57.88214631782946,
                                "left": 74.67383990094746,
                                "width": 24.038185472294003,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_4_XbQIFHr.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_3D4dFMI_AR49r1g.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm27466215",
                            "field1": "Carte casa",
                            "field2": "tuttofare",
                            "field3": "scottex",
                            "field4": "con 4 pezzi",
                            "description": "Carte casa tuttofare scottex con 4 pezzi",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.88214631782946,
                                "left": 50.879696920757965,
                                "width": 23.794142980189488,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/SCOTTEXCARTASPUGNAGIGANTEX4-5029053021416-1_YSFezLc.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_u7Yl9nn_EXXPLhZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65934489",
                            "field1": "Asciugotto",
                            "field2": "bulkysoft",
                            "field3": "conf 2 rotolo da 500 strappi",
                            "field4": "",
                            "description": "Asciugotto bulkysoft conf 2 rotolo da 500 strappi",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.88214631782946,
                                "left": 26.841511448463972,
                                "width": 24.038185472294,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/ASCIUGOTTO500STRAPPIX2-8013824740009-1_oX6Rlg5.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_Hp7AXyD_VORbM1z.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17752888",
                            "field1": "Salviette baby fresh",
                            "field2": "pampers",
                            "field3": "conf 140 pezzi",
                            "field4": "",
                            "description": "Salviette baby fresh pampers conf 140 pezzi",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 57.88214631782946,
                                "left": 3.904679873672121,
                                "width": 22.93683157479185,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_5_4fh8otR.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_lttWC1G_YOrh4T0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm97230306",
                            "field1": "Lampadine led",
                            "field2": "wolbu",
                            "field3": "goccia 60 watt attacco grande/ candel",
                            "field4": "mini globo 40 watt attacco piccolo 4 pezzi",
                            "description": "Lampadine led wolbu goccia 60 watt attacco grande/ candel mini globo 40 watt attacco piccolo 4 pezzi",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Goccia 60 Watt",
                                "Candela",
                                "Mini globo 40 Watt"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Elettronica",
                            "blueprint": {
                                "top": 74.89334356158484,
                                "left": 3.904679873672121,
                                "width": 22.93683157479185,
                                "height": 15.93453919035314
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_5oJVPpP_VRygECg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24951110",
                            "field1": "Lotto due paia fantasmini mita",
                            "field2": "'insieme per l'ambiente'",
                            "field3": "uomo/ donna/ bambino",
                            "field4": "made in italy tg 27-45",
                            "description": "Lotto due paia fantasmini mita 'insieme per l'ambiente' uomo/ donna/ bambino made in italy tg 27-45",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Abbigliamento",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 74.89334356158484,
                                "left": 26.841511448463976,
                                "width": 24.40741189348262,
                                "height": 15.93453919035314
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_NQdhr8e_gSJbwp0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93568946",
                            "field1": "Crystal ball",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Crystal ball",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi Creativi",
                            "blueprint": {
                                "top": 74.89334356158484,
                                "left": 51.248923341946586,
                                "width": 23.058852820844102,
                                "height": 15.93453919035314
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_F8kXO9T_8P6YyKc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96817227",
                            "field1": "Carta fotocopie",
                            "field2": "A4 80g",
                            "field3": "Carrefour",
                            "field4": "500 fogli",
                            "description": "Carta fotocopie A4 80g Carrefour 500 fogli",
                            "grammage": null,
                            "price": "3.00",
                            "price_label": "€ 3,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 74.78567775624461,
                                "left": 74.55498133792707,
                                "width": 22.692789082687334,
                                "height": 15.93453919035314
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/CARTAFOTOCOPIEA4500F80GN1-3390501262609-1_B2VVxHL.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_z03LgAa_NymhK6a.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_7_fgz8SaY.jpg",
                    "products": [
                        {
                            "item_id": "cstm37659058",
                            "field1": "Detergente intimo",
                            "field2": "infasil",
                            "field3": "assoriti",
                            "field4": "conf 2 pezzi da 200ml",
                            "description": "Detergente intimo infasil assoriti conf 2 pezzi da 200ml",
                            "grammage": null,
                            "price": "4.00",
                            "price_label": "€ 4,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 8.355875861326442,
                                "left": 1.2170497774906728,
                                "width": 24.648291702555266,
                                "height": 15.826873385012918
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_6_GmqP1dN.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_Cm5sNp6_iHs2syF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Infasil",
                                        "testo": "La sua formula deterge senza alterare la naturale fisiologia delle parti intime, offrendo rispetto e delicatezza. Clinicamente testato anche sulle pelli sensibili, lascia una piacevole sensazione di freschezza e benessere. Con la sua formula a pH 5,5, Infasil Intimo Neutro è ben tollerato anche da soggetti con lievi sensazioni di discomfort e con storie di intolleranza ai prodotti cosmetici. (Fonte: infasil.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/THFG3nyJd6/images/download_6_GmqP1dN.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm03135604",
                            "field1": "Carta igienica",
                            "field2": "pulito completo/ protezione delicata",
                            "field3": "scottex",
                            "field4": "conf 12 rotoli",
                            "description": "Carta igienica pulito completo/ protezione delicata scottex conf 12 rotoli",
                            "grammage": null,
                            "price": "4.00",
                            "price_label": "€ 4,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pulito completo",
                                "Protezione delicata"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 8.355875861326442,
                                "left": 25.865341480045934,
                                "width": 23.306057995980474,
                                "height": 15.826873385012918
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/CARTAIGPULCOMPLSCOTTEXX12-5029054214855-1_uXsV8RF.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_1KqRCcn_h0aoQyQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm48881092",
                            "field1": "Lettiera",
                            "field2": "ecomia",
                            "field3": "vegetale assorbiodori agglomerante",
                            "field4": "5 lt",
                            "description": "Lettiera ecomia vegetale assorbiodori agglomerante 5 lt",
                            "grammage": null,
                            "price": "4.00",
                            "price_label": "€ 4,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Care",
                            "blueprint": {
                                "top": 24.182749246339363,
                                "left": 2.071198499856452,
                                "width": 23.79414298018949,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_tQfUMaP_ftMCJNG.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_UsV24PQ_7EuCago.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm29408488",
                            "field1": "Pile",
                            "field2": "duracell plus",
                            "field3": "4 stilo o ministilo",
                            "field4": "",
                            "description": "Pile duracell plus 4 stilo o ministilo",
                            "grammage": null,
                            "price": "4.00",
                            "price_label": "€ 4,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Stilo",
                                "Ministilo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Elettronica",
                            "blueprint": {
                                "top": 24.182749246339363,
                                "left": 25.865341480045934,
                                "width": 23.306057995980474,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/DURACELLBL4PLUSAA-5000394017641-1_cQJPMWP.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_quFd8p9_HVA7aTK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/video/Duracell_Power_On__Telecomando__15s.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26216899",
                            "field1": "Doccia monogetto",
                            "field2": "cromato",
                            "field3": "",
                            "field4": "",
                            "description": "Doccia monogetto cromato",
                            "grammage": null,
                            "price": "5.00",
                            "price_label": "€ 5,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Bagno",
                            "blueprint": {
                                "top": 24.182749246339363,
                                "left": 49.171399476026416,
                                "width": 22.817973011771457,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_I5NlMZG_p14Ta4B.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06172049",
                            "field1": "Caffè",
                            "field2": "kimbo",
                            "field3": "classico conf 4 pezzi da 250g",
                            "field4": "",
                            "description": "Caffè kimbo classico conf 4 pezzi da 250g",
                            "grammage": null,
                            "price": "5.00",
                            "price_label": "€ 5,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 24.182749246339363,
                                "left": 71.98937248779787,
                                "width": 25.258397932816536,
                                "height": 16.795865633074932
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/KIMBOCLASSICOGR250X4-8002200107031-1_FBiEFEi.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_TZuo2SO_0BrQQaK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24478287",
                            "field1": "Bilancia digitale",
                            "field2": "pesa alimenti",
                            "field3": "pesa fino a 5 kg",
                            "field4": "",
                            "description": "Bilancia digitale pesa alimenti pesa fino a 5 kg",
                            "grammage": null,
                            "price": "8.00",
                            "price_label": "€ 8,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 40.978614879414295,
                                "left": 71.98937248779787,
                                "width": 25.258397932816536,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_V9NuRHE_3JQioje.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm15894432",
                            "field1": "Sabot fantasia",
                            "field2": "colori assoriti",
                            "field3": "mis 35-46",
                            "field4": "",
                            "description": "Sabot fantasia colori assoriti mis 35-46",
                            "grammage": null,
                            "price": "7.00",
                            "price_label": "€ 7,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "35",
                                "36",
                                "37",
                                "38",
                                "39",
                                "40",
                                "41",
                                "42",
                                "43",
                                "44",
                                "45",
                                "46"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Abbigliamento",
                            "subcategory": "Scarpe",
                            "blueprint": {
                                "top": 40.978614879414295,
                                "left": 49.41544196813092,
                                "width": 22.57393051966695,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_xf0JPaA_P77spXG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17797076",
                            "field1": "Centrifuga in plastica",
                            "field2": "diametro 24 cm",
                            "field3": "",
                            "field4": "",
                            "description": "Centrifuga in plastica diametro 24 cm",
                            "grammage": null,
                            "price": "5.00",
                            "price_label": "€ 5,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 40.978614879414295,
                                "left": 25.255235249784672,
                                "width": 24.16020671834625,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_PxVx27I_pZW9mej.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00503961",
                            "field1": "incontinenza",
                            "field2": "lady pants discreet tena",
                            "field3": "taglia L",
                            "field4": "conf 5 pezzi",
                            "description": "incontinenza lady pants discreet tena taglia L conf 5 pezzi",
                            "grammage": null,
                            "price": "5.00",
                            "price_label": "€ 5,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 40.978614879414295,
                                "left": 2.803325976169972,
                                "width": 22.4519092736147,
                                "height": 17.011197243755383
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_1_Yo9Hdtx_allPoYn.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_S4LM3qP_kwhye3P.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm05953077",
                            "field1": "Stendibiancheria",
                            "field2": "torre icaro",
                            "field3": "in acciaio 30mt",
                            "field4": "",
                            "description": "Stendibiancheria torre icaro in acciaio 30mt",
                            "grammage": null,
                            "price": "10.00",
                            "price_label": "€ 10,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.98981212316967,
                                "left": 2.803325976169972,
                                "width": 22.4519092736147,
                                "height": 16.903531438415158
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/images_i2AQQJb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_1gv0vxl_NYkDVU7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74144439",
                            "field1": "Set 4 asciugamani",
                            "field2": "tex",
                            "field3": "2 viso e 2 telo",
                            "field4": "100% cotone",
                            "description": "Set 4 asciugamani tex 2 viso e 2 telo 100% cotone",
                            "grammage": null,
                            "price": "10.00",
                            "price_label": "€ 10,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosa",
                                "Grigio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.98981212316967,
                                "left": 25.255235249784675,
                                "width": 24.526270456503013,
                                "height": 16.903531438415158
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/LOTTO4SPUGNE-3615005488295-1_C2w955Z.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/LOTTO4SPUGNE-3615005488301-1_1eAowV7.webp",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_MGvgoq7_80kJDHF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm87462251",
                            "field1": "Guanciale antiacaro",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Guanciale antiacaro",
                            "grammage": null,
                            "price": "10.00",
                            "price_label": "€ 10,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 57.98981212316967,
                                "left": 49.78150570628769,
                                "width": 23.18403674992822,
                                "height": 16.903531438415158
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_gRXnOsw_AG8tGpJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70914295",
                            "field1": "Lubrificante auto",
                            "field2": "Tamoil riserva rabbocco",
                            "field3": "15W40 3,5 lt",
                            "field4": "",
                            "description": "Lubrificante auto Tamoil riserva rabbocco 15W40 3,5 lt",
                            "grammage": null,
                            "price": "10.00",
                            "price_label": "€ 10,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Auto&Moto",
                            "subcategory": "Oli e liquidi",
                            "blueprint": {
                                "top": 57.98981212316967,
                                "left": 72.9655424562159,
                                "width": 23.79414298018949,
                                "height": 16.903531438415158
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/download_2_X7Q0LiH_DtVEhks.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_dDkIVdz_MWeQ33b.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_8_PuiQ99t.jpg",
                    "products": [
                        {
                            "item_id": "cstm38163772",
                            "field1": "Gormiti Ultra Tower",
                            "field2": "con luci, fumo e",
                            "field3": "tantissime trappole",
                            "field4": "meccaniche!",
                            "description": "Gormiti Ultra Tower con luci, fumo e tantissime trappole meccaniche!",
                            "grammage": null,
                            "price": "40.00",
                            "price_label": "€ 40,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 8.659610340951666,
                                "left": 4.7717622080679405,
                                "width": 45.70063694267515,
                                "height": 32.362307980517045
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_f9Cu8Wh_yWvvCGF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06455482",
                            "field1": "Trolley da cabina ABS",
                            "field2": "mis55x35x20 cm",
                            "field3": "4 ruote doppie",
                            "field4": "lucchetto a combinazione",
                            "description": "Trolley da cabina ABS mis55x35x20 cm 4 ruote doppie lucchetto a combinazione",
                            "grammage": null,
                            "price": "15.00",
                            "price_label": "€ 15,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 41.02191832146872,
                                "left": 4.7717622080679405,
                                "width": 45.70063694267515,
                                "height": 17.159985013113523
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.29.05_41oGXXz.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_RiGjExb_sgmjXHT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm58474564",
                            "field1": "Servizi piatti",
                            "field2": "18 pezzi",
                            "field3": "porcellana o stoneware",
                            "field4": "prezzi a partire da 20€",
                            "description": "Servizi piatti 18 pezzi porcellana o stoneware prezzi a partire da 20€",
                            "grammage": null,
                            "price": "20.00",
                            "price_label": "€ 20,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 58.18190333458225,
                                "left": 4.7717622080679405,
                                "width": 22.69108280254777,
                                "height": 16.677594604720866
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.29.41_KSA0pKc.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_VSKICD3_PGRHMyZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26696842",
                            "field1": "Servizi Piatti",
                            "field2": "18 pezzi",
                            "field3": "un esempio:",
                            "field4": "Olimpia Iris",
                            "description": "Servizi Piatti 18 pezzi un esempio: Olimpia Iris",
                            "grammage": null,
                            "price": "25.00",
                            "price_label": "€ 25,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 58.18190333458225,
                                "left": 27.46284501061571,
                                "width": 22.967091295116774,
                                "height": 16.677594604720866
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.29.58_YM099l8.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_tK7DW7P_LDNtBF5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60497278",
                            "field1": "Batteria",
                            "field2": "antiaderente",
                            "field3": "8 pezzi",
                            "field4": "",
                            "description": "Batteria antiaderente 8 pezzi",
                            "grammage": null,
                            "price": "30.00",
                            "price_label": "€ 30,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Pentole, padelle e pirofile",
                            "blueprint": {
                                "top": 74.85949793930311,
                                "left": 4.861995753715504,
                                "width": 45.70063694267515,
                                "height": 16.124953165979772
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.30.22_lf152qX.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_SlTsOim_ZbTr0mT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "8 pezzi",
                                    "data": {
                                        "specifiche": "casseruola 1 manico 16 cm, casseruola 2 manici 20 cm, tegame 24 cm, padella 24 e 28 cm, coperchio 16-20-24 cm",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/THFG3nyJd6/images/Schermata_2021-04-13_alle_17.30.22.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm98556482",
                            "field1": "Pentola a Pressione",
                            "field2": "Smart",
                            "field3": "5 litri",
                            "field4": "",
                            "description": "Pentola a Pressione Smart 5 litri",
                            "grammage": null,
                            "price": "20.00",
                            "price_label": "€ 20,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Pentole, padelle e pirofile",
                            "blueprint": {
                                "top": 57.82128137879355,
                                "left": 50.56263269639065,
                                "width": 49.43736730360932,
                                "height": 33.16316972648933
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.30.39_0mzKCDX.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_HxNWcxj_N2Lnb2u.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74706426",
                            "field1": "Blocco Notes",
                            "field2": "Pailletes",
                            "field3": "",
                            "field4": "",
                            "description": "Blocco Notes Pailletes",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 40.98445110528288,
                                "left": 73.8428874734607,
                                "width": 26.157112526539265,
                                "height": 16.836830273510675
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.29.28_IXI2H5Y.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_RMQvne8_CKWfJQ2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm97923815",
                            "field1": "Zaino Borsone",
                            "field2": "2 in 1",
                            "field3": "Carrefour",
                            "field4": "mis 40x29x19 cm",
                            "description": "Zaino Borsone 2 in 1 Carrefour mis 40x29x19 cm",
                            "grammage": null,
                            "price": "15.00",
                            "price_label": "€ 15,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 40.98445110528288,
                                "left": 51.1836518046709,
                                "width": 22.65923566878982,
                                "height": 16.836830273510675
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.29.18_egi1hjU.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_4wYneRh_PgBGqYZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59701831",
                            "field1": "Casetta Coloring",
                            "field2": "Bing",
                            "field3": "Soggetti assortiti",
                            "field4": "",
                            "description": "Casetta Coloring Bing Soggetti assortiti",
                            "grammage": null,
                            "price": "10.00",
                            "price_label": "€ 10,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi Creativi",
                            "blueprint": {
                                "top": 24.14293742974897,
                                "left": 51.1836518046709,
                                "width": 22.65923566878982,
                                "height": 16.84151367553391
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.28.41_PEBOwsp.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_1dKTg5j_ofCjn2D.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82121655",
                            "field1": "Zainetto",
                            "field2": "con paillettes",
                            "field3": "",
                            "field4": "",
                            "description": "Zainetto con paillettes",
                            "grammage": null,
                            "price": "5.00",
                            "price_label": "€ 5,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Abbigliamento",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 24.14293742974897,
                                "left": 73.8428874734607,
                                "width": 26.0668789808917,
                                "height": 16.84151367553391
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.28.53_zGttasy.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_jqvkvR6_Gx2Rsu6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65027728",
                            "field1": "Nerf Fortnite",
                            "field2": "SMG L",
                            "field3": "Blaster motorizzato con 3 obiettivi,",
                            "field4": "una clip removibile e 6 dardi inclusi",
                            "description": "Nerf Fortnite SMG L Blaster motorizzato con 3 obiettivi, una clip removibile e 6 dardi inclusi",
                            "grammage": null,
                            "price": "20.00",
                            "price_label": "€ 20,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 8.659610340951666,
                                "left": 73.8428874734607,
                                "width": 26.0668789808917,
                                "height": 15.483327088797301
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.28.16_rAEgFgz.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_VtwANqK_HAP8EQ8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm68221558",
                            "field1": "L.O.L. Surprise!",
                            "field2": "modelli vari",
                            "field3": "",
                            "field4": "",
                            "description": "L.O.L. Surprise! modelli vari",
                            "grammage": null,
                            "price": "10.00",
                            "price_label": "€ 10,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Boys",
                                "Sparkle",
                                "Hairgoal",
                                "Glitter",
                                "Globe"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Bambole e Peluche",
                            "blueprint": {
                                "top": 8.659610340951666,
                                "left": 51.63481953290869,
                                "width": 22.208067940552027,
                                "height": 15.483327088797301
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/Schermata_2021-04-13_alle_17.27.59_RB4WmBq.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/products/cropped_image_v2NevIc_XoAMEpt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_9_IjXa0BX.jpg",
                    "products": []
                },
                {
                    "number": 10,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_10_F0jgAUp.jpg",
                    "products": []
                },
                {
                    "number": 11,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_11_zT2FPDa.jpg",
                    "products": []
                },
                {
                    "number": 12,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_12_2l7UJpX.jpg",
                    "products": []
                },
                {
                    "number": 13,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_13_9wgX4tR.jpg",
                    "products": []
                },
                {
                    "number": 14,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_14_Va2htvc.jpg",
                    "products": []
                },
                {
                    "number": 15,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_15_2uOyK5J.jpg",
                    "products": []
                },
                {
                    "number": 16,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_16_LAv1eFm.jpg",
                    "products": []
                },
                {
                    "number": 17,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_17_bSha1lN.jpg",
                    "products": []
                },
                {
                    "number": 18,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_18_Q5gfIBP.jpg",
                    "products": []
                },
                {
                    "number": 19,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_19_7ciqrxw.jpg",
                    "products": []
                },
                {
                    "number": 20,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_20_RCfvNpt.jpg",
                    "products": []
                },
                {
                    "number": 21,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_21_lxejtwS.jpg",
                    "products": []
                },
                {
                    "number": 22,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_22_U1D01j4.jpg",
                    "products": []
                },
                {
                    "number": 23,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_23_bLloRI7.jpg",
                    "products": []
                },
                {
                    "number": 24,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_24_99AVNwm.jpg",
                    "products": []
                },
                {
                    "number": 25,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_25_kmLT3mG.jpg",
                    "products": []
                },
                {
                    "number": 26,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_26_rKEuR6t.jpg",
                    "products": []
                },
                {
                    "number": 27,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_27_xLtCg98.jpg",
                    "products": []
                },
                {
                    "number": 28,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_28_d9rSEYa.jpg",
                    "products": []
                },
                {
                    "number": 29,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_29_n9V8ldr.jpg",
                    "products": []
                },
                {
                    "number": 30,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_30_0XusIeh.jpg",
                    "products": []
                },
                {
                    "number": 31,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_31_scnlT2M.jpg",
                    "products": []
                },
                {
                    "number": 32,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_32_NAXyXF0.jpg",
                    "products": []
                },
                {
                    "number": 33,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_33_OC5DK57.jpg",
                    "products": []
                },
                {
                    "number": 34,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_34_aBkReED.jpg",
                    "products": []
                },
                {
                    "number": 35,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_35_hqYqg3v.jpg",
                    "products": []
                },
                {
                    "number": 36,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_36_JyKX89J.jpg",
                    "products": []
                },
                {
                    "number": 37,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_37_pl9OpSW.jpg",
                    "products": []
                },
                {
                    "number": 38,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_38_UQzqnKu.jpg",
                    "products": []
                },
                {
                    "number": 39,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_39_rSbDba6.jpg",
                    "products": []
                },
                {
                    "number": 40,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_40_KCNbZnf.jpg",
                    "products": []
                },
                {
                    "number": 41,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_41_I2kDWv0.jpg",
                    "products": []
                },
                {
                    "number": 42,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_42_JGzr7lA.jpg",
                    "products": []
                },
                {
                    "number": 43,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_43_9G7zffn.jpg",
                    "products": []
                },
                {
                    "number": 44,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_44_UfLv3su.jpg",
                    "products": []
                },
                {
                    "number": 45,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_45_5BuC53S.jpg",
                    "products": []
                },
                {
                    "number": 46,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_46_cJEQpzq.jpg",
                    "products": []
                },
                {
                    "number": 47,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_47_sDRhPFe.jpg",
                    "products": []
                },
                {
                    "number": 48,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_48_nUMo1Aq.jpg",
                    "products": []
                },
                {
                    "number": 49,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_49_foajiE5.jpg",
                    "products": []
                },
                {
                    "number": 50,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/page_50_nPpitSE.jpg",
                    "products": []
                },
                {
                    "number": 51,
                    "image_file": "https://interattivo.s3.amazonaws.com/THFG3nyJd6/pages/Fine-Carrefour_M2I1wJa.png",
                    "products": []
                }
            ]
        }
    }

}

const lefletSwitch = () => {
    return leaflets.carrefour;
}

export const serverResponse = lefletSwitch(); 